// extracted by mini-css-extract-plugin
export const contact = "contact-section-module--contact--1dZG0";
export const contact__details = "contact-section-module--contact__details--27O8P";
export const contact__social = "contact-section-module--contact__social--34j7d";
export const contact__inner = "contact-section-module--contact__inner--1b3sA";
export const contact__form = "contact-section-module--contact__form--woiRa";